// extracted by mini-css-extract-plugin
export default {"evaluationResultsContainer":"Evaluations_evaluationResultsContainer__vKTZ-","state":"Evaluations_state__x9JS9","reproved":"Evaluations_reproved__qjC0d"};